import { render, staticRenderFns } from "./cardCate.vue?vue&type=template&id=1f52f8ab&scoped=true&"
import script from "./cardCate.vue?vue&type=script&lang=js&"
export * from "./cardCate.vue?vue&type=script&lang=js&"
import style0 from "./cardCate.vue?vue&type=style&index=0&id=1f52f8ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f52f8ab",
  null
  
)

export default component.exports